/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();

  const { routes, onLinkClick } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  // Handle link click - close sidebar on mobile screens only
  const handleLinkClick = () => {
    // Check if screen width is less than xl breakpoint (1280px)
    // Only close sidebar on mobile/tablet screens, not on desktop
    if (window.innerWidth < 1280 && onLinkClick) {
      onLinkClick();
    }
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (
        (route.layout === "/" || route.layout === "/auth") &&
        route.name !== "Sign In"
      ) {
        return (
          <Link
            key={index}
            to={
              route.layout !== "/"
                ? route.layout + "/" + route.path
                : "/" + route.path
            }
            onClick={handleLinkClick}
          >
            <div className="relative mb-3 flex hover:cursor-pointer">
              <li
                className="my-[3px] flex cursor-pointer items-center px-8 min-w-0 w-full"
                key={index}
              >
                <span
                  className={`flex-shrink-0 ${
                    activeRoute(route.path) === true
                      ? "font-bold text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p
                  className={`leading-1 ml-4 min-w-0 ${
                    activeRoute(route.path) === true
                      ? "font-bold text-white"
                      : "font-medium text-gray-600"
                  }`}
                  style={{ wordBreak: "break-word", overflowWrap: "break-word" }}
                >
                  {route.name}
                </p>
              </li>
              {activeRoute(route.path) ? (
                <div class="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-400" />
              ) : null}
            </div>
          </Link>
        );
      }
    });
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
